import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.0.10_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_react-dom@19_kwscb4h6mv767hc5vtxiocfr3a/node_modules/next/dist/client/app-dir/link.js");
